import { compareWarehousesOzonFbsStore } from './store';

type ModalState = {
    isOpen: boolean;
};

const initialState: ModalState = {
    isOpen: false,
};

const modalSlice = compareWarehousesOzonFbsStore.createSlice({
    name: 'modal',
    initialState,
    reducers: {
        open: (state: ModalState) => {
            state.isOpen = true;
        },
        close: (state: ModalState) => {
            state.isOpen = false;
        },
    },
});

export const [useCompareWarehousesOzonFbsModal] = modalSlice.createSelector((state) => {
    return {
        isOpen: state.isOpen,
    };
});

export const openCompareWarehousesOzonFbsModal = modalSlice.open;
export const closeCompareWarehousesOzonFbsModal = modalSlice.close;
